<template>
  <div class="flex gap-4 items-center">
    <Switch
      v-model="enabled"
      :class="[
        enabled ? 'bg-primary' : 'bg-white',
        enabled ? 'border-transparent' : 'border-gray-400',
      ]"
      class="relative inline-flex h-[1.15rem] w-9 shrink-0 cursor-pointer rounded-full border-2 transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
      v-bind="$attrs"
    >
      <span
        aria-hidden="true"
        :class="[
          enabled ? 'translate-x-4' : 'translate-x-0',
          enabled ? 'bg-white' : 'bg-gray-400',
        ]"
        class="pointer-events-none inline-block h-[0.9rem] w-4 transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out"
      />
    </Switch>

    <label v-if="label" class="select-none text-base/6 text-slate-950 sm:text-sm/6 font-medium">{{ label }}</label>
  </div>
</template>

<script setup lang="ts">
import { Switch } from '@headlessui/vue'
import { watch } from 'vue'

const enabled = defineModel({
  type: Boolean,
  default: false
})

defineProps({
  label: {
    type: String,
    required: false,
  }
})

const emit = defineEmits(['change'])

watch(() => enabled.value, (value) => {
  emit('change', value)
})
</script>
